import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { IButtonProps } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledButton } from "./styles";

export type GainAccessButtonProps = IButtonProps & {
    isExploreOurPackages?: boolean;
    buttonText?: string;
};

export const GainAccessButton: FC<GainAccessButtonProps> = ({
    isExploreOurPackages = false,
    buttonText = translate(isExploreOurPackages ? "explore.our.packages" : "si.common.gain_access"),
    ...restProps
}) => {
    return (
        <StyledButton
            type="trial"
            {...restProps}
        >
            <SWReactIcons
                iconName="sparkles-gray"
                size="16px"
            />

            {buttonText}
        </StyledButton>
    );
};
